export const countEntities = () => {
    const sections = $('.data-view');
    for (let section of sections){
        const className = section.classList[1];
        const count = $(section).find('.data-row').length;
        if (!!count) $(`.section.${className} span`).text(`(${count})`);
        else $(`.section.${className} span`).text('');
    }
}
